export function checkNotifs(_obj) {
  if (!("Notification" in window)) {
    console.error("This browser does not support desktop notification");
  }
  // Let's check whether notification permissions have already been granted
  else if (Notification.permission === "granted") {
    console.log("Permission to receive notifications has been granted");
    getKeys();
  }
  // Otherwise, we need to ask the user for permission
  else if (Notification.permission !== "denied") {
    Notification.requestPermission(function (permission) {
      // If the user accepts, let's create a notification
      if (permission === "granted") {
        console.log("Permission to receive notifications has been granted");
        getKeys();
      }
    });
  }
}

export function getKeys() {
  navigator.serviceWorker
    .register("/serviceworker.js", { scope: "/" })
    .then(function (registration) {
      if (registration.pushManager) {
        return registration.pushManager.getSubscription().then(function (subscription) {
          if (subscription) {
            console.log("SUBSCRIPTION:", subscription);
            return subscription;
          }
          return registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: urlB64ToUint8Array(
              "BKXFfRP-1cvDT8G7uZpmAoG8WyE9-4t6j7SKlrcy5Iljh7TNX63os-vMSe1eBGfJF-NprTawv3gvMKibUrEnzJE="
            ),
          });
        });
      } else return false;
    })
    .then(function (subscription) {
      if (subscription) {
        sendKeys(subscription.toJSON());
      } else console.log("Browser doesn't support pushManager");
    });
}

export function sendKeys(subscription) {
  $.post("/admin/users/subscribe_to_browser_notifications", {
    subscription: subscription,
  });
}

export function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (var i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}
